import { type SearchItems } from './result-types';

export const hasSearchResults: (searchItems: SearchItems) => boolean = (searchItems: SearchItems) => {
	const sectionsWithSearchResults = searchItems.sections.filter(
		({ searchResults }) => searchResults.length > 0,
	);

	return sectionsWithSearchResults.length > 0;
};
